import { useRef, useEffect } from "react";

const Modal = ({
    size = "modal-md",
    title,
    children,
    submitBtnId,
    submitBtnText = "OK",
    cancelBtnText = "Cancel",
    showSubmitBtn = true,
    showCancelBtn = true,
    closeModal,
    footer = true,
    submitAction = () => {},
    cancelAction = () => {},
    closeAction,
    closeModalOnSubmitAction = true,
    closeModalOnCancelAction = true,
}) => {
  const refModalBackdrop = useRef();
  const styleModalBackdrop = {
    position: "fixed",
    top: "0",
    left: "0",
    zIndex: "1040",
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    overflowY:"auto"
  
  };

  useEffect(() => {
  
    if(closeModal === true){
      closeAction()
    }
  }, [closeModal])
  
  

  return (
    <div
      ref={refModalBackdrop}
      style={styleModalBackdrop}
      onClick={(event) => {
        if (event.target === refModalBackdrop.current) {
          //To restrict only to the ModalBackdrop and not modal-dialog
          closeAction();
        }
      }}
    >
      <div className={`modal-dialog ${size}`}>
        {/* size can be 'modal-sm', 'modal-md' or 'modal-lg' */}
        <div className="modal-content">
          <div className="modal-header bg-primary">
            <h5 className="modal-title text-light">
              <b>{title}</b>
            </h5>
            <button
              type="button"
              className="close btn btn-light btn-sm"
              onClick={closeAction}
            >
              <span aria-hidden="true" className="text-white">
                <b>X</b>
              </span>
            </button>
          </div>
          <div className="modal-body">{children}</div>
          {footer && (
            <div className="modal-footer">
              {showSubmitBtn && (
                <button
                  type="button"
                  className="btn btn-primary text-light pull-left"
                  id={submitBtnId}
                  onClick={(event) => {
                    submitAction(event);
                    if(closeModalOnSubmitAction) {
                      closeAction();
                    }
                  }}
                >
                  {submitBtnText}
                </button>
              )}
              {showCancelBtn && (
                <button
                  type="button"
                  className="btn btn-warning"
                  onClick={() => {
                    cancelAction();
                    if (closeModalOnCancelAction) {
                      closeAction();
                    }
                  }}
                >
                  {cancelBtnText}
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
